export const footerForUsers = {
  title: 'برای بیماران',
  links: [
    {
      title: 'دکتر آنلاین پزشکی',
      link: '/consult',
    },
    {
      title: 'نوبت دهی پزشکی',
      link: '/',
    },
    {
      title: 'نوبت دهی بیمارستان',
      link: '/',
    },
    {
      title: 'اپلیکیشن نوبت دهی پزشکان پذیرش ۲۴',
      link: '/app',
    },
    {
      title: 'جستجوی پزشکان و مراکز درمانی',
      link: '/s/',
    },
    {
      title: 'ثبت نام / ورود بیماران',
      link: '/login',
    },
    {
      title: 'سوالات متداول',
      link: '/faq/',
    },
  ],
};

export const footerPaziresh24 = {
  title: 'پذیرش24',
  links: [
    {
      title: 'تماس با ما',
      link: '/contact-us/',
    },
    {
      title: 'توسعه دهندگان',
      link: 'https://hamdast.paziresh24.com',
    },
    {
      title: 'فرصت‌های شغلی',
      link: 'https://join.paziresh24.com/',
    },
    {
      title: 'مجله سلامتی',
      link: '/blog/',
    },
    {
      title: 'حریم خصوصی',
      link: '/privacy-policy/',
    },
  ],
};
